import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { DEFAULT_LOCALE_KEY } from "@faire/web--source/common/consts/DEFAULT_LOCALE";
import { buildLocale } from "@faire/web--source/common/localization/utils";
import { logError } from "@faire/web--source/common/logging";
import { QueryParameters as NavigationCardQueryParams } from "@faire/web-api--source/api/navigation/get";
import { useQuery as useNavigationCardDataQuery } from "@faire/web-api--source/api/navigation/get-hooks";
import { useQuery as useNavigationCardHashcodeQuery } from "@faire/web-api--source/api/navigation/hashcode/get-hooks";
import { useEffect, useMemo } from "react";
export var useNavigationCardQuery = function(clientPlatformType) {
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var localeKey = getLocaleKey();
    var locale = buildLocale(localeKey !== null && localeKey !== void 0 ? localeKey : DEFAULT_LOCALE_KEY);
    var country = getSessionCountry();
    var _useNavigationCardHashcodeQuery = useNavigationCardHashcodeQuery(undefined, {
        enabled: isLoggedInRetailer
    }), navigationCardHashCodeData = _useNavigationCardHashcodeQuery.data, isNavigationCardHashcodeError = _useNavigationCardHashcodeQuery.isError, navigationCardHashcodeError = _useNavigationCardHashcodeQuery.error, refetchHashcode = _useNavigationCardHashcodeQuery.refetch;
    var navigationCardQuery = useMemo(function() {
        return NavigationCardQueryParams.build({
            retailerToken: retailerToken,
            locale: locale,
            clientPlatformType: clientPlatformType,
            country: country,
            hashCode: navigationCardHashCodeData === null || navigationCardHashCodeData === void 0 ? void 0 : navigationCardHashCodeData.navigation_hashcode
        });
    }, [
        clientPlatformType,
        country,
        locale,
        navigationCardHashCodeData === null || navigationCardHashCodeData === void 0 ? void 0 : navigationCardHashCodeData.navigation_hashcode,
        retailerToken
    ]);
    var _useNavigationCardDataQuery = useNavigationCardDataQuery(navigationCardQuery, {
        enabled: !!(navigationCardHashCodeData === null || navigationCardHashCodeData === void 0 ? void 0 : navigationCardHashCodeData.navigation_hashcode),
        staleTime: Infinity
    }), navigationCardData = _useNavigationCardDataQuery.data, isNavigationCardError = _useNavigationCardDataQuery.isError, navigationCardError = _useNavigationCardDataQuery.error;
    useEffect(function() {
        if (isNavigationCardError) {
            logError(navigationCardError);
        }
    }, [
        isNavigationCardError,
        navigationCardError
    ]);
    useEffect(function() {
        if (isNavigationCardHashcodeError) {
            logError(navigationCardHashcodeError);
        }
    }, [
        isNavigationCardHashcodeError,
        navigationCardHashcodeError
    ]);
    return {
        navigationCardData: navigationCardData,
        refetchHashcode: refetchHashcode
    };
};
